import {PlayerReduxState} from "../types";
import {Scalars} from "../../../schema";

export default function getSessionId(state: PlayerReduxState): Scalars["ID"] | null {
  return state.sessionId;
}
